import React from 'react';
import { useEffect } from 'react';
import { pageView, customEvent } from '../../Utilities/GoogleAnalytics';
import TopBar from '../../Components/TopBar';
import Footer from '../../Components/Footer';
import OutlineButton from '../../Components/OutlineButton';
import { Link } from 'react-router-dom';

export default function Affiliate() {
  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
    window.scroll(0, 0);
  }, []);

  const Inclusions = [
    {
      name: 'Ready-to-edit files',
    },
    {
      name: 'Structured Folders',
    },
    {
      name: 'Student Tools (Free)',
    },
    {
      name: 'The Complete Canada Guide',
    },
    {
      name: 'Chat Support @stamped.wiki',
    },
    {
      name: 'Members-only community',
    },
  ];

  const AffiliateInclusions = [
    {
      name: '15% flat commission',
    },
    {
      name: 'Access to dashboard',
    },
    {
      name: 'Infinite Leverage',
    },
    {
      name: 'Monetize your social following',
    },
    {
      name: 'Work experience with Stamped',
    },
    {
      name: 'Easy weekly payouts',
    },
  ];

  const TitleSection = () => {
    return (
      <>
        <div className="flex flex-col-reverse items-center h-auto pt-12 bg-white cursor-pointer lg:flex-row lg:pt-32">
          <div className="w-full mt-12 text-center lg:my-0 md:p-6 lg:p-0">
            <div className="w-full p-6 m-auto my-2 md:p-16 lg:p-24 lg:max-w-3xl">
              <h1 className="my-0 text-3xl font-bold text-brandcolor font-brand lg:text-5xl">Our partners earn an average of $4500+ per month.</h1>
              <p className="max-w-lg px-6 pt-2 m-auto text-gray-700 text-md lg:text-xl lg:p-0 lg:pt-2">
                If you are an influencer trying to find a passive income, you can do so by sharing Stamped’s products with your audience.
              </p>
              <div className="hidden my-6 space-x-2 lg:block">
                <OutlineButton reverse text={'Calculate earnings'} url={'/affiliate/earnings'} />
                <OutlineButton text={'Apply to be an affiliate'} url={'/affiliate/apply'} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const SectionTwoHeading = () => (
    <div className="flex items-center justify-center w-full m-auto text-center lg:max-w-md">
      <h1 className="p-6 m-auto my-2 text-2xl font-bold text-black font-brand lg:text-3xl">Earn money while helping your audience. Win-win.</h1>
    </div>
  );

  const BenefitCards = () => (
    <div className="max-w-2xl m-auto">
      <div className="flex flex-wrap w-full antialiased">
        <div className="w-1/2 pt-2 pb-1 pl-2 pr-1 rounded-lg lg:m-auto">
          <div className="h-full px-6 py-6 bg-darkAlt lg:px-10 lg:py-6">
            <h1 className="my-3 text-xl font-bold"> Earn big </h1>
            <p className="my-2 text-sm"> Make 15% of $50 on every referral. Even 5 referrals a day translate to $1500 CAD per month. </p>
            <a target="_blank" rel="noreferrer" href="https://stamped.wiki/affiliate/earnings">
              <p className="font-semibold underline"> Learn how </p>
            </a>
          </div>
        </div>
        <div className="w-1/2 pt-2 pb-1 pl-1 pr-2 rounded-lg">
          <div className="h-full px-6 py-6 bg-darkAlt lg:px-10 lg:py-6">
            <h1 className="my-3 text-xl font-bold"> End scams </h1>
            <p className="my-2 text-sm"> End immigration agent scams by presenting students a real solution that enables them.</p>
            <a target="_blank" rel="noreferrer" href="https://stamped.wiki/about">
              <p className="font-semibold underline"> Learn more </p>
            </a>
          </div>
        </div>
        <div className="w-1/2 pt-1 pb-2 pl-2 pr-1 rounded-lg">
          <div className="h-full px-6 py-6 bg-darkAlt lg:px-10 lg:py-6">
            <h1 className="my-3 text-xl font-bold"> Share tools </h1>
            <p className="my-2 text-sm"> Our basic tools are completely free, so everyone in your audience can use them. For life. </p>
            <a target="_blank" rel="noreferrer" href="https://stamped.wiki/tools">
              <p className="font-semibold underline"> See the tools </p>
            </a>
          </div>
        </div>
        <div className="w-1/2 pt-1 pb-2 pl-1 pr-2 rounded-lg">
          <div className="h-full px-6 py-6 bg-darkAlt lg:px-10 lg:py-6">
            <h1 className="my-3 text-xl font-bold"> Grow 10x </h1>
            <p className="my-2 text-sm"> Stamped believes in positive sum games. We can all rise by lifting others. Let’s grow together!</p>
            <a target="_blank" rel="noreferrer" href="https://stamped.wiki/affiliate/earnings">
              <p className="font-semibold underline"> Learn how </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  const TickMark = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 45 46" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.9925 6.30182C26.3664 4.68612 22.3152 4.28586 18.443 5.16072C14.5708 6.03559 11.0852 8.13871 8.50593 11.1564C5.92668 14.1741 4.39201 17.9448 4.13082 21.9059C3.86962 25.8671 4.89588 29.8066 7.05654 33.1369C9.21721 36.4671 12.3965 39.0097 16.1203 40.3855C19.844 41.7612 23.9128 41.8964 27.7196 40.7708C31.5265 39.6452 34.8675 37.3192 37.2444 34.1397C39.6214 30.9602 40.9068 27.0975 40.9091 23.1277V21.2471C40.9091 20.1174 41.8249 19.2016 42.9545 19.2016C44.0842 19.2016 45 20.1174 45 21.2471V23.1289C44.9972 27.9808 43.4261 32.7031 40.521 36.5892C37.6159 40.4752 33.5324 43.3181 28.8795 44.6938C24.2267 46.0695 19.2538 45.9043 14.7026 44.2229C10.1513 42.5414 6.26547 39.4338 3.62466 35.3635C0.983849 31.2931 -0.27047 26.4782 0.0487728 21.6368C0.368015 16.7953 2.24372 12.1868 5.39613 8.49848C8.54854 4.81016 12.8088 2.23968 17.5414 1.17039C22.2741 0.101113 27.2256 0.590324 31.6575 2.56507C32.6894 3.02484 33.1532 4.23407 32.6934 5.26594C32.2336 6.29782 31.0244 6.76159 29.9925 6.30182Z"
        fill="#18191F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.4002 5.31818C45.1994 6.11658 45.2 7.41169 44.4016 8.21089L23.9471 28.6859C23.5636 29.0698 23.0432 29.2856 22.5005 29.2857C21.9579 29.2858 21.4374 29.0703 21.0537 28.6866L14.9173 22.5502C14.1185 21.7514 14.1185 20.4563 14.9173 19.6575C15.7161 18.8587 17.0112 18.8587 17.81 19.6575L22.4993 24.3468L41.5075 5.31963C42.3059 4.52043 43.601 4.51978 44.4002 5.31818Z"
        fill="#18191F"
      />
    </svg>
  );

  const IncludedRow = ({ item }) => (
    <div className="w-full">
      <div className="flex items-center mt-6 space-x-3 text-left">
        <TickMark />
        <p className="text-lg font-bold text-black font-brand lg:text-xl">{item.name}</p>
      </div>
    </div>
  );

  const SectionThreeHeading = () => (
    <div className="flex items-center justify-center w-full m-auto mt-24 mb-24 lg:max-w-3xl">
      <div className="p-6 m-auto my-2 lg:space-y-0 lg:flex lg:space-x-6">
        {' '}
        <div>
          <h1 className="text-2xl font-bold leading-none text-brandcolor font-brand lg:text-3xl">What does Stamped give the buyers?</h1>
          {Inclusions.map((item) => (
            <IncludedRow item={item} />
          ))}
          <p className="my-12 text-xs font-normal"> All at a price that suits everyone - $50 </p>
        </div>
        <div className="mt-24 lg:mt-0">
          <h1 className="text-2xl font-bold leading-none text-brandcolor font-brand lg:text-3xl">What does Stamped give you, the affiliate?</h1>
          {AffiliateInclusions.map((item) => (
            <IncludedRow item={item} />
          ))}
          <p className="my-12 text-xs font-normal"> Earn while you truly help your audience </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <TopBar affiliatePage />
      <TitleSection />
      <SectionTwoHeading />
      <BenefitCards />
      <SectionThreeHeading />
      <div className="my-24">
        <div className="flex items-center justify-center w-full lg:m-auto">
          <div className="my-6 lg:space-x-2">
            <OutlineButton reverse text={'Calculate earnings'} url={'/affiliate/earnings'} />
            <OutlineButton text={'Apply to be an affiliate'} url={'/affiliate/apply'} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
